import React from 'react';
import './header.css';

const Header = ({name, logoUrl, websiteUrl, doSomething= null}) => {
  return (
    <div className="header-container" >
          <div className='header-left'>
            <a href={websiteUrl}>
            <img src={logoUrl} alt='logo' />
            <div className='company-name'>{name}</div>
            </a>
          </div>
          
          {doSomething && <div className='header-right'>
            <button className='btn' onClick={() => doSomething()}>Logout</button>
          </div>}

    </div>
  );
}

export default Header;
